"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sleep = void 0;
var sleep = function (time) { return new Promise(function (resolve) { return setTimeout(resolve, time); }); };
exports.sleep = sleep;
